import { JSXElementConstructor } from "react";
import { MessageContentProps } from "./types";
import { ContentType } from "@/api";
import GenericFileMessageContent from "./file-messages/GenericFileMessageContent";
import PlainTextMessageContent from "./PlainTextMessageContent";

export type MessageContentRenderer = JSXElementConstructor<MessageContentProps>;
export type MessageContentRenderers = Partial<Record<ContentType, MessageContentRenderer>>;

export const messageContentRenderers: MessageContentRenderers = {
    [ContentType.PlainText]: PlainTextMessageContent,
    [ContentType.File]: GenericFileMessageContent,
};
